import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=13401888&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=13401888&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13401888",
  null
  
)

export default component.exports